import clsx from 'clsx'
import ReactPlayer from 'react-player/lazy';
import { Button } from '../../components/atoms/Button';
import { Card } from '../../components/atoms/Card';

import {
  InstagramIcon,
  FacebookIcon,
  TwitterIcon,
} from '../../components/atoms/Icons';
import logoAirbnb from '../../assets/images/logos/airbnb.svg';
import logoFacebook from '../../assets/images/logos/Facebook.svg';
import logoPlanetaria from '../../assets/images/logos/planetaria.svg';
import logoStarbucks from '../../assets/images/logos/starbucks.svg';
import image1 from '../../assets/images/photos/image-1.jpg';
import image2 from '../../assets/images/photos/image-2.jpg';
import image3 from '../../assets/images/photos/image-3.jpg';
import image4 from '../../assets/images/photos/image-4.jpg';
import image5 from '../../assets/images/photos/image-5.jpg';
import { GallerySection } from '../../components/organism/GallerySection';
import { Header } from '../../components/atoms/Header';



interface IIcon {
  className: string
}

interface ICard {

}

interface IArticle {
  article: {
    slug: string;
    title: string;
    date: Date;
    description: string;
  }
}

interface ISocialLink {
  Icon: Element;
  href: string;
  ariaLabel: string;
}

function MailIcon(props: IIcon) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={props?.className}
    >
      <path
        d="M2.75 7.75a3 3 0 0 1 3-3h12.5a3 3 0 0 1 3 3v8.5a3 3 0 0 1-3 3H5.75a3 3 0 0 1-3-3v-8.5Z"
        className="fill-zinc-100 stroke-zinc-400 dark:fill-zinc-100/10 dark:stroke-zinc-500"
      />
      <path
        d="m4 6 6.024 5.479a2.915 2.915 0 0 0 3.952 0L20 6"
        className="stroke-zinc-400 dark:stroke-zinc-500"
      />
    </svg>
  )
}

function BriefcaseIcon(props: IIcon) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={props?.className}
    >
      <path
        d="M2.75 9.75a3 3 0 0 1 3-3h12.5a3 3 0 0 1 3 3v8.5a3 3 0 0 1-3 3H5.75a3 3 0 0 1-3-3v-8.5Z"
        className="fill-zinc-100 stroke-zinc-400 dark:fill-zinc-100/10 dark:stroke-zinc-500"
      />
      <path
        d="M3 14.25h6.249c.484 0 .952-.002 1.316.319l.777.682a.996.996 0 0 0 1.316 0l.777-.682c.364-.32.832-.319 1.316-.319H21M8.75 6.5V4.75a2 2 0 0 1 2-2h2.5a2 2 0 0 1 2 2V6.5"
        className="stroke-zinc-400 dark:stroke-zinc-500"
      />
    </svg>
  )
}

function ArrowDownIcon(props: IIcon) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M4.75 8.75 8 12.25m0 0 3.25-3.5M8 12.25v-8.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={props?.className}
      />
    </svg>
  )
}

function Article({ article }: IArticle) {
  return (
    <Card as="article">
      <>
        <Card.Title href={`/articles/${article.slug}`}>
          {article.title}
        </Card.Title>
        <Card.Eyebrow as="time" dateTime={article.date} decorate>
          {/* {formatDate(article.date)} */}
          <div>ss</div>
        </Card.Eyebrow>
        <Card.Description>{article.description}</Card.Description>
        <Card.Cta>Read article</Card.Cta>
      </>
    </Card>
  )
}




function Photos() {
  let rotations = ['rotate-2', '-rotate-2', 'rotate-2', 'rotate-2', '-rotate-2']

  return (
    <div className="mt-16 sm:mt-20">
      <div className="-my-4 flex justify-center gap-5 overflow-hidden py-4 sm:gap-8">
        {[image1, image2, image3, image4, image5].map((image, imageIndex) => (
          <div
            key={imageIndex}
            className={clsx(
              'relative aspect-[9/10] w-44 flex-none overflow-hidden rounded-xl bg-zinc-100 dark:bg-zinc-800 sm:w-56 sm:rounded-2xl',
              rotations[imageIndex % rotations.length]
            )}
          >
            <img
              src={image}
              alt=""
              sizes="(min-width: 640px) 18rem, 11rem"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default function Home() {

  return (
    <>
       <Header />
      <div className="mt-9 px-4 sm:px-2 lg:px-2 mx-auto max-w-xl  lg:max-w-4xl">
        <div className="max-w-2xl">
          <h1 className="text-2xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-4xl">
            "Pan fresco y auténtico,<br /> ¿listo para sorprender tus sentidos?<br /> Bienvenido a Aceña"
          </h1>
          <p className="mt-6 text-base dark:text-white text-gray-900">
            La panadería Aceña es la fusión perfecta de tradición y modernidad. Con ingredientes
            frescos y técnicas innovadoras, creamos panes únicos que sorprenden los sentidos y
            evocan la autenticidad de un molino harinero de agua.
          </p>
          <div className="mt-6 flex gap-6">
        
            <a className='group -m-1 p-1' href="https://www.instagram.com/acenacuba/" >

              <InstagramIcon
                href="https://www.instagram.com/acenacuba/"
                ariaLabel="Siguenos en Instagram"
                className="h-6 w-6 fill-black-900 dark:fill-zinc-400 cursor-pointer transition group-hover:fill-orange-800 dark:group-hover:fill-orange-800"
              />
            </a>
            <a className='group -m-1 p-1' href='href="https://www.facebook.com/acenacuba"'>

              <FacebookIcon
                href="https://www.facebook.com/acenacuba"
                ariaLabel="Siguenos en Facebook"
                className="h-6 w-6 fill-black cursor-pointer transition group-hover:fill-zinc-600 dark:fill-zinc-400 dark:group-hover:fill-zinc-300"
              />
            </a>
          </div>
        </div>
      </div>
      <Photos />
      <div className='mt-20 mx-auto max-w-xl lg:max-w-7xl dark:bg-zinc-800/90'>
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 pb-16 lg:relative lg:z-10 lg:pb-0">
          <div className="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-8 lg:px-8">
            <div className="relative lg:-my-8">
             {/* <div aria-hidden="true" className="absolute inset-x-0 top-0 h-1/2 bg-white sm:hidden lg:hidden" />  */}
              <div className="mx-auto max-w-md py-6 px-6 sm:max-w-3xl lg:h-full lg:p-0">
                <div className="aspect-w-10 rounded-xl aspect-h-6 overflow-hidden shadow-xl sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none lg:h-full">
                  <ReactPlayer
                    className='react-player'
                    url='https://youtu.be/PhMHtRy7m9o'
                    width='100%'
                    height='100%' 
                  />
                </div>
              </div>
            </div>
            <div className="mt-12 lg:col-span-2  lg:m-0 lg:pl-8">
              <div className="mx-auto max-w-md px-6 sm:max-w-2xl lg:max-w-none lg:px-0 lg:py-20">
                <blockquote>
                  <div>
                    <svg
                      className="h-12 w-12 text-white opacity-25"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                      aria-hidden="true"
                    >
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <p className="mt-6 text-4xl font-medium text-white">
                      Nada como un buen pan
                    </p>
                  </div>
                  <footer className="mt-6">
                    <p className="text-base font-medium text-white">Aceña</p>
                    <p className="text-base font-medium text-cyan-100"></p>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-9 mx-auto max-w-xl lg:max-w-7xl dark:bg-zinc-800/90">

        <GallerySection />

      </div>
    </>
  )
}


